import { render, staticRenderFns } from "./importShop.vue?vue&type=template&id=8debe36a"
import script from "./importShop.vue?vue&type=script&lang=js"
export * from "./importShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports